import React from 'react';
import styled from 'styled-components';
import {
  CpBody03Secondary,
  CpHeading03Primary,
  CpHeading01Primary,
  CpBody01Secondary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpMetricsVariantWidgetProps } from '../types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  overflow-y: hidden;
  gap: var(--cp-spacing-06);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Description = styled(CpBody03Secondary)`
  margin-bottom: 0;
`;

const MetricsGrid = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 40px 0;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    padding-top: 24px;
  }
`;

const MetricsCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--cp-spacing-06);
  padding: var(--cp-spacing-06);
  min-width: 350px;
  max-width: 350px;

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
    padding: var(--cp-spacing-04);
  }
`;

const MetricValue = styled(CpHeading01Primary)`
  margin-bottom: 0;

  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
`;

const MetricDescription = styled(CpBody01Secondary)`
  margin-bottom: 0;
  text-align: center;
`;

export const CpMetricsSectionWrapper = styled(CpSectionWrapper)`
  /* min-height: 0 !important; */
`;

export const CpMetricsGrid: React.FC<CpMetricsVariantWidgetProps> = ({
  disabled,
  data,
  widget,
}) => {
  const background = useGetBackground(widget);

  return (
    <CpMetricsSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={background}
    >
      <Wrapper>
        <TitleWrapper>
          <Title data-cy="cp.metrics_grid.title" autoAdjustColor>
            {data.title}
          </Title>
          <Description data-cy="cp.metrics_grid.description" autoAdjustColor>
            {data.description}
          </Description>
        </TitleWrapper>
        <MetricsGrid>
          {data?.metricsItems?.map(
            (metric, index) =>
              metric?.metric &&
              metric?.description && (
                <MetricsCard data-cy={`cp.metrics_grid.metric_${index}`}>
                  <MetricValue
                    data-cy={`cp.metrics_grid.metric_${index}.metric`}
                    autoAdjustColor
                  >
                    {metric?.metric}
                  </MetricValue>
                  <MetricDescription
                    data-cy={`cp.metrics_grid.metric_${index}.description`}
                    autoAdjustColor
                  >
                    {metric.description}
                  </MetricDescription>
                </MetricsCard>
              ),
          )}
        </MetricsGrid>
      </Wrapper>
    </CpMetricsSectionWrapper>
  );
};
